<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="48"
    width="48"
    viewBox="0 0 48 48"
  >
    <path
      d="M28.5 42q-1.2 0-2.1-.9-.9-.9-.9-2.1V9q0-1.2.9-2.1.9-.9 2.1-.9H39q1.2 0 2.1.9.9.9.9 2.1v30q0 1.2-.9 2.1-.9.9-2.1.9Zm0-33v30H39V9H28.5ZM9 42q-1.2 0-2.1-.9Q6 40.2 6 39V9q0-1.2.9-2.1Q7.8 6 9 6h10.5q1.2 0 2.1.9.9.9.9 2.1v30q0 1.2-.9 2.1-.9.9-2.1.9ZM9 9v30h10.5V9H9Zm30 0H28.5 39ZM19.5 9H9h10.5Z"
    />
  </svg>
</template>
